import { EdiCode } from 'app/core/o2c/admin/models/edi-codes-model';

import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
    selector: 'kt-edit-masters',
    templateUrl: './edit-masters.component.html',
    styleUrls: ['./edit-masters.component.scss']
})
export class EditMastersComponent implements OnInit {

    /**
     * Action to be done
     */
    @Input() title: string;

	/**
     * Action to be done
     */
    @Input() action: string;

    /**
     * Name for button
     */
    @Input() buttonNameForComponent: string;

    /**
     * Form for values to be edited
     */
    @Input() form: UntypedFormGroup;

    /**
     * List of titles and lists (if exists) for forms
     * used to fill the form fields elements in html
     */
    @Input() titlesAndLists: { title: string; list: EdiCode[]; formControlName: string }[];

    @Input() isModifyOnlyDescription: boolean = false;

    selectedCountry: string = '';

    /**
     * Object with different loaders to handle different spinners in the view,
     * according to wich petition was made
     */
    public loaders: { process: boolean; };

    constructor(
        private dialogRef: MatDialogRef<any>,
    ) { }

    ngOnInit(): void {
        /**
            console.log('gggg', this.titlesAndLists);
        */
        if (this.isModifyOnlyDescription && this.action === 'add') {
            this.isModifyOnlyDescription = false;
        }
        this.initLoaders();

        if(this.title === 'ADDRESS INFORMATION')
		{
            this.selectedCountry = this.form.controls.country.value;			

		}
    }

    /**
     * Method to start/reset the loaders for buttons
     * like sent/print, hold and release
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2019-01-22
     */
    private initLoaders(): void {
        this.loaders = {
            process: false
        };
    }

    /**
     * Closes this modal
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2021-01-05
     */
    public close(): void {
        this.dialogRef.close();
    }

    /**
     * Check if the form is valid and then send the data to the CRUD component
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2021-01-05
     */
    public process(): void {
        if (this.form.disabled) {
            this.dialogRef.close();
            return;
        }
		if(this.title === 'ADDRESS INFORMATION')
		{
			if(this.form.controls.addressTypeCode.value != 'SF')
			{
				this.form.controls.warehouse.clearValidators();
			}
			else
			{
				this.form.controls.warehouse.addValidators(Validators.required);
			}

		}
        if (this.form.valid) {
            this.loaders.process = true;
            this.dialogRef.close(this.form.value);
        } else {
            // To validate all form fields, we need to iterate throughout all form controls
            Object.keys(this.form.controls).forEach(field => {
                const control = this.form.get(field);
                control.markAsTouched({ onlySelf: true });
            });
        }
    }

    /**
     * Checks if any form control is required
     * @param abstractControl form control to be checked
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2021-01-05
     */
    hasRequiredField(abstractControl: AbstractControl): boolean {
        if (abstractControl.validator) {
            const validator = abstractControl.validator({} as AbstractControl);
            if (validator && validator.required) {
                return true;
            }
        }
        if (abstractControl['controls']) {
            for (const controlName in abstractControl['controls']) {
                if (abstractControl['controls'][controlName]) {
                    if (this.hasRequiredField(abstractControl['controls'][controlName])) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getFilteredList(formField: any) {
    if (formField.formControlName === 'state') {
        return formField.list.filter((item: any) => item.element === this.selectedCountry);
    }
    return formField.list;
}
}
